"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClioService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var ClioService = /** @class */ (function () {
    function ClioService() {
    }
    /**
     * @returns string Success
     * @throws ApiError
     */
    ClioService.getApiClioInitiateOauth = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/initiate-oauth',
        });
    };
    /**
     * @param code
     * @returns any Success
     * @throws ApiError
     */
    ClioService.getApiClioOauthCallback = function (code) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/oauth-callback',
            query: {
                'code': code,
            },
        });
    };
    /**
     * @param name
     * @returns MatterPreviewResponse Success
     * @throws ApiError
     */
    ClioService.getApiClioMatters = function (name) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/matters',
            query: {
                'name': name,
            },
        });
    };
    /**
     * @param name
     * @returns TaskPreviewResponse Success
     * @throws ApiError
     */
    ClioService.getApiClioTaskTypes = function (name) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/taskTypes',
            query: {
                'name': name,
            },
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiClioAssignTask = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/assignTask',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiUpdateTaskAssignee = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/updateTaskAssignees',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param matterId
     * @returns TaskPreviewResponse Success
     * @throws ApiError
     */
    ClioService.getApiClioMattersTasks = function (matterId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/matters/{matterId}/tasks',
            path: {
                'matterId': matterId,
            },
        });
    };
    /**
     * @param matterId
     * @returns TaskPreviewResponse Success
     * @throws ApiError
     */
    ClioService.getApiClioMattersCurrentTasks = function (matterId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/matters/{matterId}/currentTasks',
            path: {
                'matterId': matterId,
            },
        });
    };
    /**
     * @param matterId
     * @returns ContactData Success
     * @throws ApiError
     */
    ClioService.getApiClioMattersContacts = function (matterId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/matters/{matterId}/contacts',
            path: {
                'matterId': matterId,
            },
        });
    };
    /**
     * @returns ReportModel Success
     * @throws ApiError
     */
    ClioService.getApiClioEmptyMattersReport = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/emptyMattersReport',
        });
    };
    /**
     * @param requestBody
     * @returns ReportModel Success
     * @throws ApiError
     */
    ClioService.postApiClioUserReport = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/userReport',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param removeDisabled
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.getApiClioClioUsers = function (removeDisabled) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/clioUsers',
            query: {
                'removeDisabled': removeDisabled,
            },
        });
    };
    /**
     * @returns any Success
     * @throws ApiError
     */
    ClioService.getApiClioAddTaskWebhook = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/addTaskWebhook',
        });
    };
    /**
     * @returns any Success
     * @throws ApiError
     */
    ClioService.getApiClioAddMatterWebhook = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/addMatterWebhook',
        });
    };
    /**
     * @returns any Success
     * @throws ApiError
     */
    ClioService.getApiClioDeleteWebhooks = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/deleteWebhooks',
        });
    };
    /**
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiClioResetWebhooks = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/resetWebhooks',
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiClioWebhookMatterCommunicationCreation = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/webhook/matterCommunicationCreation',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiClioWebhookTaskCompletion = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/webhook/taskCompletion',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiClioWebhookTaskDueChange = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/webhook/taskDueChange',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiClioWebhookTaskAssigneeChange = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/webhook/taskAssigneeChange',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiClioWebhookMatter = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/webhook/matter',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiClioWebhookMatterCustomFieldsUpdated = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/webhook/matterCustomFieldsUpdated',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    ClioService.postApiClioTaskDataUpdate = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/taskData/{id}/update',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @returns ClioTasksInfo Success
     * @throws ApiError
     */
    ClioService.getApiClioTaskData = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/taskData',
        });
    };
    /**
     * @returns String
     * @throws ApiError
     */
    ClioService.getApiClioCheckWebhook = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/webhook/check',
        });
    };
    /**
     * @param requestBody Request body
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.postApiClioLitigationFunnelReport = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/litigationFunnelReport',
            body: requestBody,
        });
    };
    /**
     * @param matterId Matter's id
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.getApiClioLitigationFunnelMatter = function (matterId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/litigationFunnelMatter',
            query: {
                matterId: matterId
            },
        });
    };
    /**
     * @param requestBody Request body
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.postApiClioMediationReport = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/mediationReport',
            body: requestBody,
        });
    };
    /**
     * @param matterId Matter's id
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.getApiClioMediationMatter = function (matterId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/mediationMatter',
            query: {
                matterId: matterId
            },
        });
    };
    /**
     * @param query Query to search custom fields
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.getApiClioCustomFields = function (query) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/customFields',
            query: {
                query: query
            }
        });
    };
    /**
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.getApiClioLitigationMatters = function (hasTransition) {
        if (hasTransition === void 0) { hasTransition = false; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/litigationMatters',
            query: {
                hasTransition: hasTransition
            }
        });
    };
    /**
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.getApiClioMediationMatters = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/mediationMatters'
        });
    };
    /**
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.getApiClioReportNotes = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/getReportNotes',
        });
    };
    /**
     * @param requestBody Request body
     * @returns UsersModel Success
     * @throws ApiError
     */
    ClioService.postApiClioSaveReportNotes = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/saveReportNotes',
            body: requestBody,
        });
    };
    /**
     * @param startDate
     * @param endDate
     * @returns ManualTaskAssignmentReportItem Success
     * @throws ApiError
     */
    ClioService.getApiClioManualTaskAssignmentReport = function (startDate, endDate) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/manualTaskAssignmentReport',
            query: {
                startDate: startDate,
                endDate: endDate,
            },
        });
    };
    /**
     * @returns FilingReportItem Success
     * @throws ApiError
     */
    ClioService.getApiClioFilingReport = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Clio/filingReport',
        });
    };
    ClioService.postApiClioSaveFilingReportStatuses = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/filingReport/statuses',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    ClioService.postApiClioDownloadFilingReport = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/filingReport/download',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    ClioService.postApiClioLloFunnelReport = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/lloFunnelReport',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    ClioService.postApiClioDownloadLloFunnelReport = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Clio/lloFunnelReport/download',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    return ClioService;
}());
exports.ClioService = ClioService;
//# sourceMappingURL=ClioService.js.map